import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from '../../../models/Organization';
import { OrganizationService } from '../../../services/organization.service';
import { AppConstants } from '../../../utils/AppConstants';
import { Device } from '../../../models/Device';
import { DeviceService } from '../../../services/device.service';
import QRCodeStyling from "qr-code-styling";
import { AlertService } from '../../shared/alert/alert.service';
@Component({
  selector: 'app-device-detail',
  standalone: true,
  imports: [CommonModule, HasPermissionDirective, ConfirmAlertComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './device-detail.component.html',
  styleUrl: './device-detail.component.scss'
})
export class DeviceDetailComponent implements OnInit, OnDestroy {
  paramSubscription!: Subscription;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | 'RESET' | undefined = undefined;

  id?: string;
  isNew: boolean = true;
  device: Device = {};
  detail_title: string = 'Nuovo palmare';

  organizations: Organization[] = [];
  @ViewChild("canvas") canvas?: ElementRef;
  qrCodeShow: boolean = false;

  constructor(
    private deviceService: DeviceService,
    private organizationService: OrganizationService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit(): void {
    this.findOrganizations();
    this.paramSubscription = this.activatedRoute.params.subscribe(parameter => {
      this.id = parameter['id'];
      this.id = this.id != "undefined" ? this.id : undefined;
      console.log(this.id)
      if (this.id != undefined) {
        this.fullSpinnerService.spinner('');
        this.isNew = false;
        this.deviceService.get(this.id).subscribe({
          next: (res) => {
            this.device = res;
            this.detail_title = res.name!;
          }, complete: () => {
            this.fullSpinnerService.spinner(undefined);
          }
          , error: () => {
            this.fullSpinnerService.spinner(undefined);
          }
        });
      }
    });
  }

  private findOrganizations() {
    this.organizationService.find({ pageSize: -1 }).subscribe({
      next: (res) => {
        this.organizations = res.items;
      }, complete: () => {
      }
      , error: () => {
      }
    });
  }

  showQrcode() {
    if (!this.qrCodeShow) {
      const qrCode = new QRCodeStyling({
        width: 500,
        height: 500,
        margin: 7,
        data: this.device.id!,
        image: "logo.svg",
        dotsOptions: {
          color: "#000000",
          type: "rounded",
        },

        imageOptions: {
          crossOrigin: "anonymous",
          margin: 7,
        },
      });


      qrCode.append(this.canvas!.nativeElement);
    }
    else
      this.canvas!.nativeElement.innerHTML = '';


    this.qrCodeShow = !this.qrCodeShow;
  }

  onSubmit(loginForm: NgForm): void {
    if (loginForm.valid) {
      this.fullSpinnerService.spinner('');
      this.deviceService.save(this.device).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.router.navigate(['devices']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

  back() {
    this.router.navigate(['devices']);
  }

  confirmDelete() {
    this.showConfirmationModal = true;
    this.confirmOperationType = 'DEL';
    this.confirmationMessage = "Sicuro di voler eliminare il palmare " + this.device.name + ' ?';
  }

  confirmReset() {
    this.showConfirmationModal = true;
    this.confirmOperationType = 'RESET';
    this.confirmationMessage = "Sicuro di voler resettare il palmare " + this.device.name + ' ?';
  }

  pairing() {
    this.fullSpinnerService.spinner('');
    this.deviceService.preCoupling(this.device.id!).subscribe({
      next: (_) => {
        this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
        this.router.navigate(['devices']);
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }
  delete() {
    this.fullSpinnerService.spinner('');
    this.deviceService.delete(this.device.id!).subscribe({
      next: (res) => {
        this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
        this.router.navigate(['devices']);
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  reset() {
    this.fullSpinnerService.spinner('');
    this.deviceService.reset(this.device.id!).subscribe({
      next: (res) => {
        this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  cancelModalOperationExec() {
    this.showConfirmationModal = false;
    this.confirmOperationType = undefined;
  }

  modalOperationExec() {
    const operationType = this.confirmOperationType;
    this.cancelModalOperationExec();
    if (operationType === 'DEL') this.delete();
    else if (operationType === 'RESET') this.reset();
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}
